/**
 * Flags e permissões do módulo ARCA (front).
 * Apresentação desabilitada para todos (código preservado).
 * Processo de pagamento / administrativo: Setor de Contratos, Admin, Gerência corporativa.
 */

import { isUsuarioSetorContratos } from '../../../utils/contratosDashboardUtils';

/** Feature flag — não apagar páginas; apenas ocultar/redirecionar. */
export const ARCA_APRESENTACAO_HABILITADA = false;

const PROCESSOS_RESTRITOS_PATHS = [
  '/arca/pdf/processo-pagamento',
  '/arca/pdf/processo-administrativo',
];

export function isArcaProcessoRestritoPath(pathname = '') {
  return PROCESSOS_RESTRITOS_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}

/**
 * @param {{ user?: object, isAdmin?: boolean, isFiscal?: boolean, isCargoCorporativo?: boolean, rbacRole?: string }} auth
 */
export function canAccessArcaProcessosContratos(auth = {}) {
  const user = auth.user || null;
  if (!user && !auth.isAdmin) return false;

  if (auth.isAdmin || user?.isAdmin) return true;

  const role = String(auth.rbacRole || user?.role || '').toUpperCase();
  if (['SUPER_ADMIN', 'ADMIN', 'CORPORATE_MANAGER'].includes(role)) {
    return true;
  }

  if (
    isUsuarioSetorContratos({
      user,
      isAdmin: auth.isAdmin,
      isFiscal: auth.isFiscal,
    })
  ) {
    return true;
  }

  const email = String(user?.email || '').trim().toLowerCase();
  if (email === 'rafael.santana.cs@isgsaude.org') return true;

  const tipo = String(user?.tipo || user?.perfil || '').toLowerCase();
  const cargo = String(user?.cargo || '').toLowerCase();
  const setor = String(user?.setor || user?.departamento || '').toLowerCase();

  // Gerência corporativa (de contratos)
  if (tipo === 'gerente_corporativo' || cargo.includes('gerente corporativo')) {
    return true;
  }
  if (auth.isCargoCorporativo && (setor.includes('contrato') || /contrato/.test(tipo))) {
    return true;
  }

  return false;
}
